import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";

const Footer = () => {
  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="bg-[#000033] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10 lg:py-12">
        {/* Main Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-6 sm:gap-8 lg:gap-10 mb-8">
          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-sm sm:text-base tracking-wide uppercase mb-3 sm:mb-4">
              QUICK LINKS
            </h3>
            <ul className="space-y-2 text-gray-300">
              {[
                { name: "Home", path: "/" },
                { name: "Explore Locality", path: "/explore-locality" },
                { name: "Top Agents", path: "/agents" },
                { name: "Interior Design Ideas", path: "/interior" },
                { name: "Post a Property", path: "/post-property" },
                { name: "Login / Register", path: "/login" },
              ].map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    onClick={handleLinkClick}
                    className="text-xs sm:text-sm text-[#FBFBFB] hover:text-gray-200 transition-colors inline-block"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="font-semibold text-sm sm:text-base tracking-wide uppercase mb-3 sm:mb-4">
              COMPANY
            </h3>
            <ul className="space-y-2 text-gray-300">
              {[
                { name: "About Us", path: "/about" },
                { name: "Help Center", path: "/help" },
                { name: "Privacy Policy", path: "/policy" },
                { name: "Terms & Conditions", path: "/terms" },
              ].map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    onClick={handleLinkClick}
                    className="text-xs sm:text-sm text-[#FBFBFB] hover:text-gray-200 transition-colors inline-block"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Properties */}
          <div>
            <h3 className="font-semibold text-sm sm:text-base tracking-wide uppercase mb-3 sm:mb-4">
              PROPERTIES
            </h3>
            <ul className="space-y-2 text-gray-300">
              {[
                { name: "All Properties", path: "/properties" },
                { name: "Commercial Properties", path: "/properties/commercial" },
                { name: "Land & Plots", path: "/properties/land" },
                { name: "New Projects", path: "/properties/project" },
              ].map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    onClick={handleLinkClick}
                    className="text-xs sm:text-sm text-[#FBFBFB] hover:text-gray-200 transition-colors inline-block"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Partners */}
          <div>
            <h3 className="font-semibold text-sm sm:text-base tracking-wide uppercase mb-3 sm:mb-4">
              PARTNERS
            </h3>
            <ul className="space-y-2 text-gray-300">
              {[
                "https://naukri.com",
                "https://shiksha.com",
                "https://housing.com",
                "https://squareyard.com",
                "https://jeevansathi.com",
              ].map((url, index) => (
                <li key={index}>
                  <button
                    onClick={() => window.open(url, "_blank")}
                    className="text-xs sm:text-sm text-[#FBFBFB] hover:underline bg-transparent border-none cursor-pointer p-0 text-left"
                  >
                    {url.replace("https://", "")}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* About & Contact */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 lg:gap-10 pt-6 border-t border-gray-700/50">
          {/* About Us */}
          <div className="lg:col-span-2">
            <h3 className="font-semibold text-sm sm:text-base tracking-wide uppercase mb-3 sm:mb-4">
              ABOUT US
            </h3>
            <p className="text-xs sm:text-sm text-[#FBFBFB]/90 leading-relaxed">
              At LeadBook, we're redefining the way real estate connects. Our
              platform bridges the gap between buyers, sellers, agents, and
              builders, offering a transparent, fast, and reliable property
              experience. From verified listings to advanced lead management,
              LeadBook helps agents grow their business, builders showcase
              projects with impact, and buyers find their dream homes with
              confidence.
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-semibold text-sm sm:text-base tracking-wide uppercase mb-3 sm:mb-4">
              CONTACT US
            </h3>
            <div className="space-y-3 text-xs sm:text-sm">
              <div>
                <p className="text-gray-400 mb-1">Write to us at</p>
                <button
                  onClick={() =>
                    (window.location.href = "mailto:connect@leadbook.com")
                  }
                  className="text-[#FBFBFB] hover:underline hover:text-gray-200 transition-colors"
                >
                  connect@leadbook.com
                </button>
              </div>
              <div>
                <p className="text-gray-400 mb-1">Existing Clients</p>
                <button
                  onClick={() =>
                    (window.location.href = "mailto:customercare@leadbook.com")
                  }
                  className="text-[#FBFBFB] hover:underline hover:text-gray-200 transition-colors"
                >
                  customercare@leadbook.com
                </button>
              </div>
              <div className="pt-1">
                <p className="text-gray-400 mb-1">Office Address</p>
                <p className="text-[#FBFBFB] leading-relaxed">
                  Branvision Enterprises, Kalinga Nagar, <br />
                  Khandagiri, Ghatikia, <br />
                  Bhubaneswar-751003
                </p>
              </div>
            </div>
          </div>

          {/* Social Icons */}
          <div>
            <h3 className="font-semibold text-sm sm:text-base tracking-wide uppercase mb-3 sm:mb-4">
              FOLLOW US
            </h3>
            <div className="flex flex-wrap gap-3 sm:gap-4">
              {[
                {
                  icon: <FaFacebookF />,
                  color: "hover:text-blue-400",
                  link: "https://facebook.com",
                },
                {
                  icon: <FaInstagram />,
                  color: "hover:text-pink-400",
                  link: "https://instagram.com",
                },
                {
                  icon: <FaLinkedinIn />,
                  color: "hover:text-blue-400",
                  link: "https://linkedin.com",
                },
                {
                  icon: <FaYoutube />,
                  color: "hover:text-red-400",
                  link: "https://youtube.com",
                },
              ].map((social, index) => (
                <button
                  key={index}
                  onClick={() => window.open(social.link, "_blank")}
                  className={`text-xl sm:text-2xl ${social.color} transition-all duration-300 hover:-translate-y-0.5`}
                  aria-label={`Social media link ${index + 1}`}
                >
                  {social.icon}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="border-t border-gray-700/50 mt-6 sm:mt-8 pt-4 sm:pt-5 flex flex-col sm:flex-row justify-between items-center text-gray-400 text-[10px] sm:text-xs gap-2">
          <p>All rights reserved ©{new Date().getFullYear()} - LEADBOOK</p>
          <p>
            Designed & Developed by-
            <a
              target="_blank"
              rel="noreferrer"
              className="px-0.5 cursor-pointer hover:text-blue-500"
              href="https://www.webbocket.com/"
            >
              Web_Bocket
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
// import { Link } from "react-router-dom";
// import {
//   FaFacebookF,
//   FaInstagram,
//   FaLinkedinIn,
//   FaYoutube,
// } from "react-icons/fa";

// const Footer = () => {
//   const handleLinkClick = () => {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

//   return (
//     <footer className="bg-[#000033] text-white">
//       <div className="mx-auto px-4 sm:px-6 lg:px-10 py-10">
//         {/* Main Grid */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
//           {/* Quick Links */}
//           <div>
//             <h3 className="font-semibold text-lg sm:text-xl lg:text-[20px] uppercase mb-4">
//               QUICK LINKS
//             </h3>
//             <ul className="space-y-2 sm:space-y-3 text-gray-300">
//               {[
//                 { name: "About Us", path: "/about" },
//                 { name: "Top Agents", path: "/find-agent" },
//                 { name: "Property on Sell", path: "/properties" },
//                 { name: "Interior Design Idea", path: "/interior" },
//                 { name: "RERA Verified Projects", path: "/properties" },
//               ].map((link, index) => (
//                 <li key={index}>
//                   <Link
//                     to={link.path}
//                     onClick={handleLinkClick}
//                     className="text-sm sm:text-base lg:text-[16px] text-[#FBFBFB] hover:text-gray-200 transition-colors"
//                   >
//                     {link.name}
//                   </Link>
//                 </li>
//               ))}
//             </ul>
//           </div>

//           {/* Company */}
//           <div>
//             <h3 className="font-semibold text-lg sm:text-xl lg:text-[20px] uppercase mb-4">
//               COMPANY
//             </h3>
//             <ul className="space-y-2 sm:space-y-3 text-gray-300">
//               {[
//                 { name: "Help Center", path: "/help" },
//                 { name: "Policy of Use", path: "/policy" },
//                 { name: "Blogs & FAQs", path: "/blogs" },
//                 { name: "Market Insights", path: "/insights" },
//                 { name: "Terms & Conditions", path: "/terms" },
//               ].map((link, index) => (
//                 <li key={index}>
//                   <Link
//                     to={link.path}
//                     onClick={handleLinkClick}
//                     className="text-sm sm:text-base lg:text-[16px] text-[#FBFBFB] hover:text-gray-200 transition-colors"
//                   >
//                     {link.name}
//                   </Link>
//                 </li>
//               ))}
//             </ul>
//           </div>

//           {/* Properties */}
//           <div>
//             <h3 className="font-semibold text-lg sm:text-xl lg:text-[20px] uppercase mb-4">
//               PROPERTIES
//             </h3>
//             <ul className="space-y-2 sm:space-y-3 text-gray-300">
//               {[
//                 { name: "Flats/ Villas", path: "/flats" },
//                 { name: "1, 2, 3 BHK, 1 Rk", path: "/bhk" },
//                 { name: "Independent House", path: "/independent-house" },
//                 { name: "Residential Property", path: "/residential" },
//                 { name: "Independent Building Floor", path: "/building-floor" },
//               ].map((link, index) => (
//                 <li key={index}>
//                   <Link
//                     to={link.path}
//                     onClick={handleLinkClick}
//                     className="text-sm sm:text-base lg:text-[16px] text-[#FBFBFB] hover:text-gray-200 transition-colors"
//                   >
//                     {link.name}
//                   </Link>
//                 </li>
//               ))}
//             </ul>
//           </div>

//           {/* Partners */}
//           <div>
//             <h3 className="font-semibold text-lg sm:text-xl lg:text-[20px] uppercase mb-4">
//               PARTNERS
//             </h3>
//             <ul className="space-y-2 sm:space-y-3 text-gray-300">
//               {[
//                 "https://naukri.com",
//                 "https://shiksha.com",
//                 "https://housing.com",
//                 "https://squareyard.com",
//                 "https://jeevansathi.com",
//               ].map((url, index) => (
//                 <li key={index}>
//                   <button
//                     onClick={() => window.open(url, "_blank")}
//                     className="text-sm sm:text-base lg:text-[16px] text-[#FBFBFB] hover:underline bg-transparent border-none cursor-pointer p-0"
//                   >
//                     {url.replace("https://", "")}
//                   </button>
//                 </li>
//               ))}
//             </ul>
//           </div>
//         </div>

//         {/* About & Contact */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mt-6">
//           {/* About Us */}
//           <div className="lg:col-span-2">
//             <h3 className="font-semibold text-lg sm:text-xl lg:text-[20px] uppercase mb-4">
//               ABOUT US
//             </h3>
//             <p className="text-sm sm:text-base lg:text-[16px] text-[#FBFBFB] leading-relaxed">
//               At LeadBook, we're redefining the way real estate connects. Our
//               platform bridges the gap between buyers, sellers, agents, and
//               builders, offering a transparent, fast, and reliable property
//               experience. From verified listings to advanced lead management,
//               LeadBook helps agents grow their business, builders showcase
//               projects with impact, and buyers find their dream homes with
//               confidence.
//             </p>
//           </div>

//           {/* Contact Info */}
//           <div>
//             <h3 className="font-semibold text-lg sm:text-xl lg:text-[20px] uppercase mb-4">
//               CONTACT US
//             </h3>
//             <div className="space-y-3 text-sm sm:text-base lg:text-[16px]">
//               <div>
//                 <p>Write to us at</p>
//                 <button
//                   onClick={() =>
//                     (window.location.href = "mailto:connect@leadbook.com")
//                   }
//                   className="hover:underline"
//                 >
//                   connect@leadbook.com
//                 </button>
//               </div>
//               <div>
//                 <p>Existing Clients</p>
//                 <button
//                   onClick={() =>
//                     (window.location.href = "mailto:customercare@leadbook.com")
//                   }
//                   className="hover:underline"
//                 >
//                   customercare@leadbook.com
//                 </button>
//               </div>
//             </div>
//           </div>

//           {/* Social Icons */}
//           <div>
//             <h3 className="font-semibold text-lg sm:text-xl lg:text-[20px] uppercase mb-4">
//               FOLLOW US
//             </h3>
//             <div className="flex flex-wrap gap-4 sm:gap-5">
//               {[
//                 {
//                   icon: <FaFacebookF />,
//                   color: "hover:text-blue-400",
//                   link: "https://facebook.com",
//                 },
//                 {
//                   icon: <FaInstagram />,
//                   color: "hover:text-pink-400",
//                   link: "https://instagram.com",
//                 },
//                 {
//                   icon: <FaLinkedinIn />,
//                   color: "hover:text-blue-400",
//                   link: "https://linkedin.com",
//                 },
//                 {
//                   icon: <FaYoutube />,
//                   color: "hover:text-red-400",
//                   link: "https://youtube.com",
//                 },
//               ].map((social, index) => (
//                 <button
//                   key={index}
//                   onClick={() => window.open(social.link, "_blank")}
//                   className={`text-2xl sm:text-3xl ${social.color} transition-transform duration-300 transform hover:-translate-y-1`}
//                 >
//                   {social.icon}
//                 </button>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* Footer Bottom */}
//         <div className="border-t border-gray-700 mt-10 pt-6 flex flex-col sm:flex-row justify-between items-center text-gray-400 text-xs sm:text-sm lg:text-[16px] text-center gap-3">
//           <p>All rights reserved ©{new Date().getFullYear()} - LEADBOOK</p>
//           <p>Designed & Developed by Web_Bocket</p>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;
